// extracted by mini-css-extract-plugin
export default {"container":"TabsContainer_container__ZivoM"};